import Vue from "vue";

let eventBus = new Vue({
	data() {
		return {
			mouse: {
				x: 0,
				y: 0,
				screenX: 0,
				screenY: 0,
				left: false,
				right: false,
				dragging: false
			}
		};
	},
	// eslint-disable-next-line max-lines-per-function
	created() {
		window.addEventListener("click", (event) => {
			eventBus.$emit("window-click", event);
		});
		window.addEventListener("resize", (event) => {
			eventBus.$emit("window-resize", {width: window.innerWidth, height: window.innerHeight});
		});
		window.addEventListener("mousemove", (event) => {
			this.mouse.x = event.pageX;
			this.mouse.y = event.pageY;
			this.mouse.screenX = event.screenX;
			this.mouse.screenY = event.screenY;
		});
		window.addEventListener("mousedown", (event) => {
			if (event.button == 0) {
				this.mouse.left = true;
			}
			if (event.button == 2) {
				this.mouse.right = true;
			}
		});
		window.addEventListener("mouseup", (event) => {
			if (event.button == 0) {
				this.mouse.left = false;
			}
			if (event.button == 2) {
				this.mouse.right = false;
			}
		});
		window.addEventListener("touchmove", (event:TouchEvent)=>{
			let touch = event.touches.item(0) as Touch;
			this.mouse.x = touch.pageX;
			this.mouse.y = touch.pageY;
			this.mouse.screenX = touch.screenX;
			this.mouse.screenY = touch.screenY;
		});
		window.addEventListener("touchstart", (event:TouchEvent)=>{
			if(event.touches.length > 0){
				this.mouse.left = true;
			}
		});
		window.addEventListener("touchend", (event:TouchEvent)=>{
			if (event.touches.length == 0){
				this.mouse.left = false;
			}
		});
		window.addEventListener("touchcancel", (event:TouchEvent)=>{
			if (event.touches.length == 0){
				this.mouse.left = false;
			}
		});
	}
});

export default eventBus;